/* Restaurant Halong: Gratis Mini Frühlingsrollen mit ROLLEN-Code.

   Shopify Functions sind auf Basic mit einer Custom App nicht erlaubt (siehe README). Deshalb:
   - Das Theme legt die Rollen als eigene, markierte Warenkorb-Zeile ab (Eigenschaft _halong_gratis, im Warenkorb und
     an der Kasse versteckt).
   - Gratis wird die Zeile durch den vorhandenen Klaviyo-Rabatt (7,50 € Festbetrag ab 25 €): Zeile 7,50 €, Rabatt -7,50 €,
     Summe für die Rollen 0 €.
   Rückweg: Script-Zeile in layout/theme.liquid entfernen; die markierte Zeile bleibt dann im Warenkorb stehen, der Gast
   kann sie selbst entfernen. */
(function (root, factory) {
  var logik = factory();
  if (typeof module === 'object' && module.exports) module.exports = logik;
  else root.HalongRollenLogik = logik;
  if (typeof document !== 'undefined' && !root.__halongRollen) { root.__halongRollen = true; logik.starte(root); }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var KONFIG = {
    variantId: 56573280223581,
    mindestCent: 2500,          // Mindestbestellwert des Rabatts, ohne die Rollen gerechnet
    codePraefix: /^ROLLEN/i,
    markierung: '_halong_gratis',
    zustandKey: 'halongRollenZustand'
  };

  /** Code aus dem Cookie discount_code (Shopify setzt es bei /discount/CODE auch für ungültige Codes). */
  function codeAusCookie(cookieText) {
    var teile = String(cookieText || '').split(/;\s*/);
    for (var i = 0; i < teile.length; i++) {
      if (teile[i].indexOf('discount_code=') === 0) {
        try { return decodeURIComponent(teile[i].slice(14)).trim(); } catch (e) { return ''; }
      }
    }
    return '';
  }

  function istRollenCode(code) { return KONFIG.codePraefix.test(String(code || '')); }

  function verwaltet(item) { return Boolean(item.properties && item.properties[KONFIG.markierung]); }

  /** Warenwert ohne die verwalteten Rollen, in Cent (vor Rabatt). */
  function warenwertOhneRollen(cart) {
    return (cart.items || []).reduce(function (s, i) {
      return verwaltet(i) ? s : s + (i.original_line_price != null ? i.original_line_price : i.line_price);
    }, 0);
  }

  /**
   * Reine Entscheidung. Eingabe: Warenkorb (cart.js), aktueller Code, bisheriger Zustand.
   * Ausgabe: { aktion, zustand } mit aktion null | {typ:'hinzufuegen'} | {typ:'setzen', updates:{key:menge}}.
   * Zustand: { code, hinzu (wir haben die Zeile gesetzt), entfernt (Gast hat sie entfernt) }.
   */
  function entscheide(cart, code, zustandAlt) {
    var z = { code: code || '', hinzu: false, entfernt: false };
    if (zustandAlt && zustandAlt.code === z.code && z.code) { z.hinzu = !!zustandAlt.hinzu; z.entfernt = !!zustandAlt.entfernt; }
    var zeilen = (cart.items || []).filter(verwaltet).filter(function (i) { return i.variant_id === KONFIG.variantId; });
    var andere = (cart.items || []).filter(verwaltet).filter(function (i) { return i.variant_id !== KONFIG.variantId; });
    var updates = {};
    andere.forEach(function (i) { updates[i.key] = 0; });

    var codeAktiv = istRollenCode(z.code);
    if (!codeAktiv) {
      z.hinzu = false; z.entfernt = false;
      zeilen.forEach(function (i) { updates[i.key] = 0; });
      return { aktion: Object.keys(updates).length ? { typ: 'setzen', updates: updates } : null, zustand: z };
    }
    // Gast hat die Zeile selbst entfernt: nicht wieder hinzufügen.
    if (zeilen.length === 0 && z.hinzu) { z.entfernt = true; z.hinzu = false; }

    var ausreichend = warenwertOhneRollen(cart) >= KONFIG.mindestCent;
    if (!ausreichend) {
      zeilen.forEach(function (i) { updates[i.key] = 0; });
      z.hinzu = false;   // fällt der Wert unter 25 €, entfernen wir selbst: das ist kein Entfernen durch den Gast
      return { aktion: Object.keys(updates).length ? { typ: 'setzen', updates: updates } : null, zustand: z };
    }
    if (z.entfernt) return { aktion: Object.keys(updates).length ? { typ: 'setzen', updates: updates } : null, zustand: z };

    if (zeilen.length === 0) { z.hinzu = true; return { aktion: { typ: 'hinzufuegen', updates: updates }, zustand: z }; }
    z.hinzu = true;
    if (zeilen[0].quantity !== 1) updates[zeilen[0].key] = 1;
    zeilen.slice(1).forEach(function (i) { updates[i.key] = 0; });
    return { aktion: Object.keys(updates).length ? { typ: 'setzen', updates: updates } : null, zustand: z };
  }

  function starte(w) {
    var doc = w.document;
    var wurzel = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    var laeuft = false, nochmal = false, timer = null;

    function lies() { try { return JSON.parse(w.sessionStorage.getItem(KONFIG.zustandKey) || 'null'); } catch (e) { return null; } }
    function schreibe(z) { try { w.sessionStorage.setItem(KONFIG.zustandKey, JSON.stringify(z)); } catch (e) { /* gesperrt: ohne Gedächtnis */ } }
    function code() { return codeAusCookie(doc.cookie); }
    function cartLaden() { return w.fetch(wurzel + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }

    function abgleichen() {
      if (laeuft) { nochmal = true; return; }
      laeuft = true;
      cartLaden().then(function (cart) {
        var e = entscheide(cart, code(), lies());
        schreibe(e.zustand);
        if (!e.aktion) return null;
        var schritte = Promise.resolve();
        if (Object.keys(e.aktion.updates || {}).length) {
          schritte = schritte.then(function () {
            return w.fetch(wurzel + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: e.aktion.updates }) });
          });
        }
        if (e.aktion.typ === 'hinzufuegen') {
          var props = {}; props[KONFIG.markierung] = 'ROLLEN';
          schritte = schritte.then(function () {
            return w.fetch(wurzel + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: KONFIG.variantId, quantity: 1, properties: props }] }) });
          });
        }
        return schritte.then(function () { doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
      }).catch(function () { /* Netzfehler: nächster Abgleich holt es nach */ }).then(function () {
        laeuft = false;
        if (nochmal) { nochmal = false; plane(200); }
      });
    }
    function plane(ms) { w.clearTimeout(timer); timer = w.setTimeout(abgleichen, ms); }

    // Auslöser: Seitenaufruf, jede Warenkorb-Änderung, Rückkehr in den Tab. Eigene Änderungen lösen über cart:refresh
    // nur einen zweiten, dann folgenlosen Abgleich aus.
    doc.addEventListener('cart:change', function () { plane(400); });
    doc.addEventListener('cart:refresh', function () { plane(400); });
    w.addEventListener('pageshow', function () { plane(100); });
    plane(100);

    w.HalongRollen = Object.freeze({ abgleichen: abgleichen, code: code });
    if (w.HalongRollenCodefeld) w.HalongRollenCodefeld(w, abgleichen);
  }

  return { KONFIG: KONFIG, codeAusCookie: codeAusCookie, istRollenCode: istRollenCode, entscheide: entscheide, warenwertOhneRollen: warenwertOhneRollen, starte: starte };
});
